import { useMutation, useQueryClient } from "react-query";
import { uploadCustomerDocumentAsync } from "api/customers";

export function useUploadCustomerDocument() {
  const queryClient = useQueryClient();

  const {
    mutateAsync: uploadDocument,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  } = useMutation(uploadCustomerDocumentAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries("customer-documents");
    },
    onError: (error) => {
      console.error("Error uploading document:", error);
    },
  });

  return {
    uploadDocument,
    isLoading,
    isError,
    error,
    isSuccess,
    data,
  };
}
